'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var Tab$1 = require('../../../node_modules/@material-ui/core/esm/Tab/Tab.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = function useStyles(accessoryLeft) {
  return makeStyles["default"](function (theme) {
    return {
      root: {
        minWidth: 56,
        maxWidth: 120,
        textTransform: 'none',
        '&:hover': {
          opacity: 1
        }
      },
      tabWithAccessory: {
        width: '100%',
        justifyContent: accessoryLeft ? 'left' : 'space-between',
        alignItems: 'center',
        display: 'flex'
      },
      secondaryStyle: {
        marginRight: accessoryLeft ? theme.spacing(0) : theme.spacing(3)
      }
    };
  });
};

var Tab = React__default["default"].forwardRef(function (_ref, ref) {
  var version = _ref.version,
      label = _ref.label,
      secondary = _ref.secondary,
      accessoryLeft = _ref.accessoryLeft,
      rest = objectWithoutProperties(_ref, ["version", "label", "secondary", "accessoryLeft"]);

  var _useStyles = useStyles(accessoryLeft)(),
      root = _useStyles.root,
      tabWithAccessory = _useStyles.tabWithAccessory,
      secondaryStyle = _useStyles.secondaryStyle;

  if (version === 'v2') {
    var labelComponent = secondary ? React__default["default"].createElement("div", {
      className: tabWithAccessory
    }, React__default["default"].createElement("span", null, label), React__default["default"].createElement("div", {
      className: secondaryStyle
    }, secondary)) : label;
    return React__default["default"].createElement(Tab$1["default"], _objectSpread({
      label: labelComponent,
      classes: _objectSpread({
        root: root
      }, rest.classes),
      ref: ref
    }, rest));
  } else {
    return React__default["default"].createElement(Tab$1["default"], _objectSpread({
      label: label
    }, rest, {
      ref: ref
    }));
  }
});

module.exports = Tab;
